import { render, staticRenderFns } from "./ApPagaBuoni.vue?vue&type=template&id=3ba9e734&scoped=true"
import script from "./ApPagaBuoni.vue?vue&type=script&lang=js"
export * from "./ApPagaBuoni.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba9e734",
  null
  
)

export default component.exports